import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import {
  approveGstStatus,
  blockUser,
  deleteCategory,
  disapproveGstStatus,
  getCountries,
  getUser,
  unblockUser,
  updateGstStatus,
} from "services/ApiService"
import TableContainer from "../../components/Common/TableContainer"
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { toast, ToastContainer } from "react-toastify"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLock, faUnlock } from "@fortawesome/free-solid-svg-icons"
import Loader from "components/Common/Loader"
import UserDataTable from "components/Common/UserDataTable"
import { base_url } from "utils/APIUrls"
// import Swal from "sweetalert2"
// import "sweetalert2/dist/sweetalert2.min.css"

function User() {
  const [country, setCountry] = useState([])

  useEffect(() => {
    fetchCountryData()
  }, [])

  const fetchCountryData = () => {
    getCountries().then(res => {
      setCountry(res.data)
    })
  }
  //meta title
  document.title = "Users | Telepathic Dashboard "

  return (
    <div className="page-content">
      <Breadcrumbs title="Dashboard" breadcrumbItem="Users" />

      <ToastContainer />
      <div className="container-fluid">
        <UserDataTable
          apiURL={`${base_url}/admin/v1/user/get-users`}
          idName="users"
          countries={country}
        />
      </div>
    </div>
  )
}

User.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default User
